// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3D9qW","left":"styles_left__-i5-a"};